import cn from 'classnames'
import { observer } from 'mobx-react'
import { useTranslation } from 'react-i18next';

import { Text } from '@/components/Text'

import styles from './AuthTitle.module.scss'

interface AuthTitleProps {
  containerClassName?: string;
	subtitle: string;
}

export const AuthTitle = observer(function AuthTitle(props: AuthTitleProps) {
  const {
		containerClassName,
		subtitle
	} = props

	const { t } = useTranslation();

  const containerClasses = cn(styles.container, containerClassName)

	return (
		<div className={containerClasses}>
			<Text
				containerClassName={styles.desctop}
				variant='h1-mob'
				color='accsent-4s'
				alignment='center'
			>
				{`${t('AuthTitle:Greetings')} `}
				<Text variant='h1-desctop'>
					Govori
					<Text color='accsent-3s'>
						Ru
					</Text>
				</Text>
			</Text>

			<Text
				containerClassName={styles.mobile}
				variant='h1-mob'
				alignment='center'
			>
				{`${t('AuthTitle:Greetings')} `}
				<Text
					color='accsent-4s'
				>
					Govori
					<Text color='accsent-3s'>
						Ru
					</Text>
				</Text>
			</Text>

			<Text
				variant='text-2-semibold'
				color='base-dl'
				alignment='center'
			>
				{subtitle}
			</Text>
		</div>
	)
})
